import { Box, Tooltip as MuiTooltip, Tab, type Theme } from '@mui/material';
import type { ComponentType, ElementType, ReactNode } from 'react';
import Icon from '../../../Icon/Icon';

interface PopoverTabProps {
  value: string;
  label: ReactNode;
  icon?: ElementType;
  disabled?: boolean;
  blockedReason?: string;
  testId?: string;
}

type Props = PopoverTabProps & Record<string, unknown>;

const BLOCKED_TAB_SX = (theme: Theme) => ({
  opacity: theme.palette.action.disabledOpacity,
  cursor: 'default',
});

const PopoverTab = ({
  icon,
  value,
  label,
  disabled,
  blockedReason,
  testId,
  ...muiInternals
}: Props) => {
  const MuiTab = Tab as ComponentType<Record<string, unknown>>;
  const isBlocked = !!blockedReason;

  const tab = (
    <MuiTab
      icon={icon ? <Icon icon={icon} size="sm" /> : undefined}
      iconPosition="start"
      value={value}
      label={
        <Box
          component="span"
          sx={{
            minWidth: 0,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {label}
        </Box>
      }
      disabled={disabled}
      aria-disabled={isBlocked || undefined}
      sx={isBlocked ? BLOCKED_TAB_SX : undefined}
      test-id={testId}
      {...muiInternals}
    />
  );

  if (!blockedReason) {
    return tab;
  }

  return (
    <MuiTooltip describeChild title={blockedReason}>
      {tab}
    </MuiTooltip>
  );
};

export type { PopoverTabProps };
export default PopoverTab;
